var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.corporationAccount)?_c('CPublicCorporationProfilePage',{attrs:{"corporation-account":_vm.corporationAccount}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }